import {useListView} from '../../core/ListViewProvider'
import {PlanFeaturesListToolbar} from './PlanFeaturesListToolbar'
import {PlanFeaturesListGrouping} from './PlanFeaturesListGrouping'
import {PlanFeaturesListSearchComponent} from './PlanFeaturesListSearchComponent'

const PlanFeaturesListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <PlanFeaturesListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <PlanFeaturesListGrouping /> : <PlanFeaturesListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {PlanFeaturesListHeader}
